import { Injectable } from '@angular/core';
import { IHttpInterceptor } from '@covalent/http-deprec';
import { MatSnackBar } from '@angular/material';
import { Response } from '@angular/http';

const SNACK_BAR_DURATION:number = 15000;
const SNACK_BAR_ACTION:string = 'schließen';
const EXCLUDE_PATH_ERROR:string[] = ['/admin', '/verlosung/registrierung?spielid', '/blacklist', '/sepa'];
const EXCLUDE_PATH_OK:string[] = ['/login', '/agbs'];

@Injectable()
export class HttpErrorHandlingInterceptor implements IHttpInterceptor {

  constructor(private snackBar:MatSnackBar) {
  }

  onResponseError(error:Response):Response {
    var bodyMsg = this.getResponseMessage(error.json());

    if (bodyMsg && !this.isPathExcluded(error.url, true)) {
      this.openErrorBar(bodyMsg);
    }

    return error;
  }

  onResponse(response:Response):Response {
    if (response.ok) {
      let respJson: any;
      try {
        respJson = response.json();
      } catch (e) {
        console.log(e);
        return response;
      }
      let bodyMsg = this.getResponseMessage(respJson);
      if (bodyMsg && !this.isPathExcluded(response.url, false)) {
        this.openSuccessBar(bodyMsg);
      }
    }
    return response;
  }

  private getResponseMessage(responseBody:any):string {
    if (responseBody) {
      try {
        if (responseBody.message) {
          console.info("Request message: " + responseBody.status + " -- " + responseBody.message);
          return responseBody.message;
        }
      } catch (e) {
        return null;
      }
    }
  }

  private isPathExcluded(path:string, isError:boolean):boolean {
    var exclude = isError ? EXCLUDE_PATH_ERROR : EXCLUDE_PATH_OK;

    for (var i = 0; i < exclude.length; i++) {
      if (path.indexOf(exclude[i]) > -1) {
        return true;
      }
    }
    return false;
  }


  private openErrorBar(message:string):void {
    this.snackBar.open(message, SNACK_BAR_ACTION, {
      duration: SNACK_BAR_DURATION,
      panelClass: ["az-message-bar", "bgc-red-400"]
    });
  }

  private openSuccessBar(message:string):void {
    this.snackBar.open(message, SNACK_BAR_ACTION, {
      duration: SNACK_BAR_DURATION,
      panelClass: ["az-message-bar", "bgc-green-400"]
    });
  }

}
